export default __webpack_public_path__ + "static/media/yliopisto2.a2aeff54.jpg";